import { UNIT_OPTIONS } from "./settings";

export interface RangeType {
  imperial: string;
  metric: string;
  value: number;
}

export interface EnumType {
  label: string;
  localizedLabel: string;
  value: any;
}


export const getEnumLabelByValue = (e: readonly EnumType[], value?: any): string | undefined => {
  if (value === undefined) return undefined;
  var range = e.find(r => r.value === value);
  return range?.label;
};

export const getUnitEnumLabelByValue = (ranges: readonly RangeType[], value?: any, unit?: string): string | undefined => {
  if (value === undefined) return undefined;
  var range = ranges.find(r => r.value === value);
  return unit?.toUpperCase() === UNIT_OPTIONS.METRIC.toUpperCase() ? range?.metric : range?.imperial;
};

export const getUnitEnumValueByLabel = (ranges: readonly RangeType[], label?: string, unit?: string): any | undefined => {
  if (label === undefined) return undefined;
  var range = ranges.find(r => unit?.toUpperCase() === UNIT_OPTIONS.METRIC.toUpperCase() ? r.metric === label : r.imperial === label);
  return range?.value;
};

export const getUnitEnumLabelByUnit = (range: RangeType, unit?: string): string =>
  (unit?.toUpperCase() === UNIT_OPTIONS.METRIC.toUpperCase() ? range.metric : range.imperial);
